const authHr = {
    "sign_in": "Prijava",
    "email": "E-mail adresa",
    "password": "Lozinka",
    "sign_in_button": "Prijava",
    "invalid_credentials": "Nevažeće vjerodajnice",
    "password_min_length": "Lozinka mora biti dugačka najmanje 8 znakova",
    "passwords_do_not_match": "Lozinke se ne podudaraju",
    "invalid_token": "Nevažeći token",
    "password_set": "Lozinka postavljena",
    "confirm_password": "Potvrdite lozinku",
    "confirm_title": "Potvrda o registraciji administratora Quickpicka",
    "confirm_text": "Za postavljanje računa, samo trebate unijeti sigurnu lozinku",
    "set_password": "Postavi lozinku",
    "account_activated": "Račun aktiviran",
    "account_activated_text": "Sada se možete prijaviti na svoj korisnički račun s navedenom adresom e-pošte i lozinkom",
    "continue_to_login": "Nastavite s prijavom",
    "forgotten_password": "Zaboravljena lozinka",
    "unable_to_reset_password": "Interna greška, nije moguće resetirati lozinku.",
    "reset_password_title": "Poništi lozinku",
    "reset_password_text": "Molimo unesite adresu e-pošte koju koristite za svoj račun. Poslat ćemo vam poveznicu za resetiranje lozinke na tu adresu e-pošte.",
    "send_reset_mail": "Pošalji link za resetiranje lozinke",
    "send_reset_mail_success": "Na navedenu adresu poslana je e-pošta s daljnjim uputama",
    "invalid_email": "Nevažeća adresa e-pošte",
    "reset_sent": "E-pošta poslana",
    "change_password_title": "Promjena lozinke",
    "change_password_success": "Lozinka je uspješno promijenjena",
    "roles": {
        "OWNER": "Administrator",
        "MENU_EDITOR": "Uređivanje jelovnika",
        "STAFF_MANAGER": "Upravljanje osobljem"
    },
    "name": "Ime",
    "permissions": "Dozvole",
    "create_user_permissions": "Stvaranje korisničkih dozvola",
    "add_restaurant": "Dodaj restoran",
    "user_saved": "Korisnik je spremljen",
    "has_admin_permissions": "Administratorska dopuštenja",
    "login_with_google": "Prijava putem Googlea",
    "missing_perrmissions": "Nemate potrebna dopuštenja za pristup ovoj stranici",
    "qp_signup_title": "Brza registracija",
    "qp_signup_text": "Ispunite polja ispod kako biste kreirali korisnički račun!",
    "user_information": "Podaci o korisniku",
    "restaurant_information": "Informacije o restoranu",
    "restaurant_shortname": "Identifikator restorana",
    "restaurant_name": "Naziv restorana",
    "create_profile": "Stvoriti",
    "restaurant_name_short": "Naziv restorana mora imati najmanje 3 znaka",
    "identifier_example": "Primjer identifikatora",
    "invalid_shortname": "Identifikator restorana mora imati najmanje 3 znaka",
    "restaurant_shortname_already_in_use": "Identifikator restorana već se koristi",
    "name_missing": "Nedostaje ime",
    "signup_failed": "Registracija nije uspjela. Pokušajte ponovno kasnije.",
    "no_restaurant_title": "Nije odabran nijedan restoran za vaš račun",
    "no_restaurant_text": "Ako ste upravo kreirali svoj račun, trebali biste registrirati i svoj restoran!",
    "no_restaurant_alt": "Ako biste trebali dobiti pristup restoranu, obratite se administratoru restorana.",
    "no_user_created_yet": "Još nemate račun?",
    "signup_success": "Registracija uspješna",
    "grant_admin_title": "Dodijeli administratorske dozvole",
    "grant_admin_confirmation": "Korisnik s administratorskim dozvolama može upravljati postavkama restorana, dodavati i uklanjati korisnike, upravljati pretplatama, plaćanjima i računima. Za uređivanje jelovnika nisu potrebna administratorska dopuštenja.",
    "selected_user": "Odabrani korisnik",
    "delete_user_title": "Ukloni korisnika",
    "delete_user_confirmation": "Odabrani korisnik bit će uklonjen iz restorana i više neće imati pristup njegovom jelovniku. Ovu radnju nije moguće poništiti.",
    "admin": "Administrator",
    "activate_account": "Aktiviraj račun",
    "account_pending_activation": "Vaš korisnički račun čeka aktivaciju.",
    "check_your_activate_email": "Molimo provjerite pristiglu poštu i kliknite na aktivacijsku poveznicu",
    "refresh_page": "Osvježi stranicu",
    "did_not_receive_activation_email": "Nisam primio/la aktivacijsku e-poštu",
    "activate_tip": "Ako ne možete pronaći aktivacijsku e-poštu, provjerite i mapu neželjene pošte. Ako je nema tamo, kliknite gumb ispod da biste je ponovno poslali.",
    "resend_email": "Ponovno pošalji",
    "email_resent": "Aktivacijska e-pošta uspješno je ponovno poslana. Molimo provjerite pristiglu poštu.",
    "accept_terms_and_conditions": "Pročitao/la sam i prihvaćam <a>Uvjete i odredbe te Pravila o privatnosti</a>",
    "complete_registration": "Dovršite registraciju",
    "auth_in_progress": "Autentifikacija u tijeku...",
    "account_successfully_activated": "Vaš QuickPick račun je uspješno aktiviran",
    "continue_to_home_page": "Nastavite na početnu stranicu",
    "invalid_activation": "Došlo je do pogreške prilikom aktivacije računa. Pokušajte ponovno kasnije ili se obratite našoj korisničkoj podršci.",
    "activation_mail_sent": "Započeli smo s izradom vašeg računa. Molimo provjerite pristiglu poštu i dovršite registraciju klikom na poveznicu u e-poruci."
};

export default authHr;
